import { Fragment } from 'react'
import Slider from 'react-slick'
import get from 'lodash/get'
import './photo-gallery-slick.scss'

export default function HeroGalleryMobile({ photos }) {
  if(!get(photos, 'length')) {
    return null
  }
  const settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    dots: true,
    dotsClass: 'custom-paging',
    customPaging: (i) => (
      <Fragment>
        {i + 1} / {photos.length}
      </Fragment>
    ),
  }
  return (
    <Slider className='slick-pt-custom photo-gallery-slick' {...settings}>
      {photos.slice(0, 30).map((photo, index) => {
        return (
          <img
            src={photo.src}
            key={index}
            alt={photo.caption}
            data-index={index}
          />
        )
      })}
    </Slider>
  )
}
